(() => {
  'use strict';
  const root = document.getElementById('MjsDiamondHomeSchedule');
  if (!root || root.dataset.initialised) return;
  root.dataset.initialised = 'true';
  const start = Date.parse(root.dataset.start);
  const end = Date.parse(root.dataset.end);
  const before = root.querySelector('[data-diamond-home-before]');
  const active = root.querySelector('[data-diamond-home-live]');
  if (!before || !active || !Number.isFinite(start) || !Number.isFinite(end) || end <= start) return;
  let timer;
  const update = () => {
    window.clearTimeout(timer);
    const now = Date.now();
    const state = now < start ? 'upcoming' : now < end ? 'live' : 'ended';
    if (state === 'live') {
      const template = active.querySelector('[data-diamond-home-template]');
      if (template) template.replaceWith(template.content.cloneNode(true));
    }
    before.hidden = state !== 'upcoming';
    active.hidden = state !== 'live';
    root.dataset.state = state;
    // Use wall time on every visit, wake and boundary; never depend on a manual launch.
    const next = state === 'upcoming' ? start : state === 'live' ? end : 0;
    if (next && !document.hidden) timer = window.setTimeout(update, Math.min(Math.max(1, next - now), 2147483647));
  };
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pageshow', update);
  update();
})();
